export const ru = {
    cancel: 'Отмена',
    create: 'Создать',
    'new-creative': 'Новый креатив'
};
